module.exports = __webpack_public_path__ + "static/img/welcome-banner.6aa35219.png";